import RelatedDocumentsList from 'components/RelatedDocumentsList/RelatedDocumentsListPresentation'

export default {
  Presentation: RelatedDocumentsList,
}
